export default "__VITE_ASSET__pm5uxgJs__"